import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	ForgotPasswordSendToken,
	ForgotPasswordSendTokenParams,
	ForgotPasswordSendTokenModel,
} from 'domain/usecases';

export class RemoteForgotPasswordSendToken implements ForgotPasswordSendToken {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<ForgotPasswordSendTokenModel>,
	) {}

	async sendToken({
		signal,
		...bodyParams
	}: ForgotPasswordSendTokenParams): Promise<ForgotPasswordSendTokenModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: bodyParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
